import batchHandleUrl from '../../../utils/url-handle'
const api = {
  // aPaas上传文件校验信息
  paasCheckInfo: {
    url: '/apaas/field/getFileCheckInfo',
    type: 'post',
    parameter: {
      'apiName': String, // 字段apiName
      'objectApiname': String, // 字段所属对象apiName
      'version': String // 版本号
    }
  },
  getAccessoryToken: {
    // url: '/userauth/userLogin/getAccessoryToken',
    url: '/userauth/assist/getAccessoryToken',
    type: 'get'
  },
  getPreviewKeyName: {
    url: '/apaas/file/preview/get',
    type: 'post'
  }
}
export default batchHandleUrl(api)